import Component from './component'
import withPermissions from '../../../../globals/components/withPermissions'

export default withPermissions(Component)
